<main>
  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'stations.rollsControl' | translateWF: 'Rolls Control' }}</h1>
      </div>
    </div>

    @if (isLoading() > 0) {
      <loading-overlay [isLoading]="true"></loading-overlay>
    }

    <!-- Search Section -->
    <p-panel [header]="'RollSplit.searchParentRoll' | translateWF: 'Search Parent Roll'">
      <ng-template pTemplate="icons">
        <p-inputgroup>
          <input pInputText type="text" class="flex-1 text-xl p-4" [formControl]="searchInput" (keyup.enter)="searchRollByCode()" />
          <p-inputgroup-addon>
            <p-button [text]="true" [outlined]="true" icon="pi pi-search" size="large" (onClick)="searchRollByCode()" />
          </p-inputgroup-addon>
        </p-inputgroup>
      </ng-template>
    </p-panel>

    @if (parentRoll()) {
      <div class="grid-12">
        <!-- Parent Roll Information -->
        <div class="span-12-12-6">
          <p-panel [header]="'RollSplit.parentRollInformation' | translateWF: 'Parent Roll Information'">
            <p-card>
              <div class="space-y-4">
                <div class="form-box-row">
                  <label>{{ 'RollSplit.rollNumber' | translateWF: 'Roll Number' }}</label>
                  <input pInputText [value]="parentRoll()?.number" type="text" class="w-full" [disabled]="true" />
                </div>

                <div class="form-box-row">
                  <label>{{ 'RollSplit.knittingOrder' | translateWF: 'Knitting Order' }}</label>
                  <input pInputText [value]="parentRoll()?.knittingOrderNumber" type="text" class="w-full" [disabled]="true" />
                </div>

                <div class="form-box-row">
                  <label>{{ 'RollSplit.currentWeight' | translateWF: 'Current Weight (Lbs)' }}</label>
                  <input pInputText [value]="getLatestQuantityForRoll(parentRoll()) + ' Lbs'" type="text" class="w-full" [disabled]="true" />
                </div>

                <div class="form-box-row">
                  <label>{{ 'RollSplit.description' | translateWF: 'Description' }}</label>
                  <input pInputText [value]="fabric()?.greige?.longDescription" type="text" class="w-full" [disabled]="true" />
                </div>
              </div>
            </p-card>
          </p-panel>

          <!-- Split Controls -->
          <p-panel styleClass="mt-6" [header]="'RollSplit.splitRoll' | translateWF: 'Split Roll'">
            <p-card>
              <div class="space-y-4">
                <div class="form-box-row">
                  <label class="text-lg font-medium">{{ 'RollSplit.newRollWeight' | translateWF: 'New Roll Weight (Lbs)' }}</label>
                  <input
                    pInputText
                    type="number"
                    class="w-full text-2xl p-6"
                    [placeholder]="'RollSplit.enterWeightPlaceholder' | translateWF: 'Enter weight for new roll'"
                    [formControl]="newRollWeight"
                    min="0.1"
                    step="0.1"
                  />
                </div>

                <div class="flex justify-end">
                  <p-button
                    [label]="'RollSplit.splitRoll' | translateWF: 'Split Roll'"
                    [disabled]="!canSplit"
                    [loading]="isLoading() > 0"
                    size="large"
                    (onClick)="performRollSplit()"
                  />
                </div>
              </div>
            </p-card>
          </p-panel>
        </div>

        <!-- Children Rolls Table -->
        <div class="span-12-12-6">
          <p-panel>
            <ng-template pTemplate="header">
              <span>{{ 'RollSplit.childrenRolls' | translateWF: 'Children Rolls' }} ({{ childrenRolls().length }})</span>
            </ng-template>

            @if (childrenRolls().length > 0) {
              <p-card data-variant="compact">
                <p-table [value]="childrenRolls()" [scrollable]="true" scrollHeight="500px">
                  <ng-template #header>
                    <tr>
                      <th class="text-left">{{ 'RollSplit.rollNumber' | translateWF: 'Roll Number' }}</th>
                      <th class="text-right">{{ 'RollSplit.weight' | translateWF: 'Weight (Lbs)' }}</th>
                      <th class="text-right">{{ 'RollSplit.print' | translateWF: 'Print' }}</th>
                    </tr>
                  </ng-template>
                  <ng-template #body let-roll>
                    <tr>
                      <td class="font-mono text-lg">{{ roll.number }}</td>
                      <td class="text-right text-lg font-semibold">
                        {{ roll.netQuantity | number: '1.2-2' }}
                      </td>
                      <td class="text-right">
                        <p-button [icon]="'pi pi-print'" [text]="true" (onClick)="printQrCode(roll.number)"></p-button>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </p-card>
            } @else {
              <p-panel data-tone="surface">
                <div class="text-center py-8 text-gray-500">
                  <i class="pi pi-info-circle text-3xl mb-4 block"></i>
                  <p class="text-lg">
                    {{
                      'RollSplit.noChildrenFound'
                        | translateWF
                          : 'No children rolls found for this parent
                roll.'
                    }}
                  </p>
                  <p class="text-sm">
                    {{
                      'RollSplit.splitToCreateChildren'
                        | translateWF
                          : 'Split the roll to create
                children.'
                    }}
                  </p>
                </div>
              </p-panel>
            }
          </p-panel>
        </div>
      </div>
    } @else {
      <div class="text-center py-12">
        <i class="pi pi-search text-6xl text-gray-300 mb-4 block"></i>
        <h3 class="text-xl text-gray-500 mb-2">
          {{
            'RollSplit.searchForParentRoll'
              | translateWF
                : 'Search for a Parent
        Roll'
          }}
        </h3>
        <p class="text-gray-400">
          {{
            'RollSplit.enterRollNumberPrompt'
              | translateWF
                : 'Enter a roll number above to get
        started with splitting.'
          }}
        </p>
      </div>
    }
  </div>
</main>
